module.exports = (__parcel__import__("bNsCc")).then(() => parcelRequire('kRw5D'));